var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var CampaignService = /** @class */ (function (_super) {
    __extends(CampaignService, _super);
    function CampaignService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this._subject = new Subject();
        _this.usersCount = new UsersCount();
        _this.segments = [];
        return _this;
    }
    Object.defineProperty(CampaignService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CampaignService.prototype.setUsersCount = function (usersCount) {
        this.usersCount = new UsersCount();
        if (typeof usersCount !== 'undefined') {
            for (var key in this.usersCount) {
                if (typeof usersCount[key] !== 'undefined') {
                    this.usersCount[key] = usersCount[key];
                }
            }
        }
    };
    CampaignService.prototype.getUsersCount = function (scope) {
        if (scope) {
            return this.usersCount.includeLower;
        }
        return this.usersCount.current;
    };
    CampaignService.prototype.getTarget = function (rec, number) {
        var value = rec['target_value'] ? parseInt(rec['target_value']) : 0;
        var percent = rec['target_percent'] ? parseInt(rec['target_percent']) : 0;
        number = number || 0;
        if (rec['target_type'] === 'value') {
            if (value < 0) {
                value = 0;
            }
            if (number > 0) {
                percent = Math.floor(value / number * 100);
            }
        }
        else {
            if (percent < 0) {
                percent = 0;
            }
            value = Math.floor(percent * number / 100);
        }
        return { percent: percent, value: value, number: number };
    };
    CampaignService.prototype.getTargetMsg = function (rec, number, msg) {
        var data = this.getTarget(rec, number);
        msg = msg.replace(/\{\{value\}\}/g, data['value'].toString());
        msg = msg.replace(/\{\{percent\}\}/g, data['percent'].toString());
        msg = msg.replace(/\{\{number\}\}/g, data['number'].toString());
        return msg;
    };
    CampaignService.prototype.sortPriority = function (segments) {
        segments.sort(function (a, b) {
            if (a.priority < b.priority) {
                return -1;
            }
            if (a.priority > b.priority) {
                return 1;
            }
            return 0;
        });
    };
    // Segment
    CampaignService.prototype.getSegmentSetList = function () {
        var _this = this;
        this.baseUrl = '/v1/gen/segment-set-m-service-regist-api?query={"orderByList": [{"name":"segment_set_id","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.segment_set_id, display: item.segment_set_title });
            }
            _this.logger.debug('options:', options);
            return options;
        }));
    };
    CampaignService.prototype.getSegmentSet = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/segment-set-m-service-regist-api?query={"orderByList": [{"name":"segment_m.priority","direction":"asc"}],"predicateList": [{"name":"segment_set_id","value":"' + id + '","operator":"eq"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data.items[0]);
            return data.items[0];
        }));
    };
    CampaignService.prototype.getFragmentList = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/attribute-segment-fragment-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data.items);
            return data.items;
        }));
    };
    CampaignService.prototype.setSegments = function (segments) {
        this.segments = segments;
    };
    CampaignService.prototype.checkSegmentItem = function (rec) {
        var check = true;
        if (!this.colservice.checkVal(rec['segment_set_title'])) {
            check = false;
        }
        var segmentsErr = [];
        if (this.segments.length > 0) {
            for (var _i = 0, _a = this.segments; _i < _a.length; _i++) {
                var segment = _a[_i];
                if (!this.colservice.checkVal(segment['segment_title'])) {
                    check = false;
                }
                var fragmentsErr = [];
                if (segment['fragments'].length > 0) {
                    for (var _b = 0, _c = segment['fragments']; _b < _c.length; _b++) {
                        var fragment = _c[_b];
                        if (fragment['segment_disp_type'] === 'unique' && fragment['value']) {
                            fragmentsErr.push(false);
                        }
                        else if (fragment['segment_disp_type'] === 'multiple' && fragment['values'].length > 0) {
                            fragmentsErr.push(false);
                        }
                        else if (fragment['segment_disp_type'] === 'range' && (fragment['value1'] || fragment['value2'])) {
                            fragmentsErr.push(false);
                        }
                        else {
                            fragmentsErr.push(true);
                            check = false;
                        }
                    }
                }
                else if (segment['is_editable'] === true) {
                    check = false;
                }
                segmentsErr.push(fragmentsErr);
            }
        }
        else {
            check = false;
        }
        if (!check) {
            this._subject.next({ segment: { segmentsErr: segmentsErr } });
        }
        return check;
    };
    // Measure
    CampaignService.prototype.getCampaignMeasureList = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-measure-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data;
        }));
    };
    // Content
    CampaignService.prototype.getLanguageList = function () {
        var _this = this;
        this.baseUrl = '/v1/language';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data.items);
            return data.items;
        }));
    };
    CampaignService.prototype.getCampaignList = function () {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-m-result-service?query={"orderByList":[{"name":"campaign_id","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.campaign_id, display: item.title });
            }
            _this.logger.debug('options:', options);
            return options;
        }));
    };
    CampaignService.prototype.getCampaign = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-m-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data;
        }));
    };
    // Timing
    CampaignService.prototype.getCampaignTimingTypeList = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-timing-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data;
        }));
    };
    // Confirm
    CampaignService.prototype.getCampaignConfirm = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-confirm-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data;
        }));
    };
    // Estimate
    CampaignService.prototype.getCampaignEstimate = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-estimate-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data;
        }));
    };
    // Report
    CampaignService.prototype.postCampaignReport = function (rec) {
        var _this = this;
        this.baseUrl = '/v1/gen/campaign-report-api';
        return _super.prototype.postRecord.call(this, rec).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data;
        }));
    };
    CampaignService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CampaignService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return CampaignService;
}(ContentBaseService));
export { CampaignService };
var UsersCount = /** @class */ (function () {
    function UsersCount() {
        this.current = 0;
        this.includeLower = 0;
    }
    return UsersCount;
}());
//# sourceMappingURL=campaign.service.js.map